import React from 'react';
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { Form, FormGroup, FormControl, Button, Row, Col, Alert } from 'react-bootstrap';
import config from '../../../config';

class Profile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            username: '',
            loading: false,
            success: false,
            error: '',
            user: null
        };
    }

    componentDidMount() {
        try {
            const userData = localStorage.getItem('user');
            if (!userData) {
                return;
            }

            const user = JSON.parse(userData);
            this.setState({
                firstName: user.firstName || '',
                lastName: user.lastName || '',
                email: user.email || '',
                username: user.username || '',
                user: user
            });
        } catch (error) {
            console.error('Error loading user data:', error);
            this.setState({ error: 'Failed to load user data' });
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value, success: false, error: '' });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        
        const { firstName, lastName, email, user } = this.state;
        
        if (!user || !user.id) {
            this.setState({ error: 'User information not found' });
            return;
        }

        this.setState({ loading: true, success: false, error: '' });

        // Update profile via API
        fetch(`${config.apiUrl}/updateProfile?id=${user.id}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                firstName: firstName,
                lastName: lastName,
                email: email
            })
        })
        .then((response) => {
            if (response.status === 200) {
                // Update localStorage with new user data
                const updatedUser = {
                    ...user,
                    firstName: firstName,
                    lastName: lastName,
                    email: email
                };
                localStorage.setItem('user', JSON.stringify(updatedUser));
                
                this.setState({ 
                    loading: false, 
                    success: true,
                    user: updatedUser
                });
                
                // Clear success message after 3 seconds
                setTimeout(() => {
                    this.setState({ success: false });
                }, 3000);
            } else {
                return response.text().then(text => {
                    throw new Error(text || 'Failed to update profile');
                });
            }
        })
        .catch((error) => {
            console.error('Error updating profile:', error);
            this.setState({ 
                loading: false, 
                error: error.message || 'Failed to update profile. Please try again.' 
            });
        });
    }

    render() {
        const { firstName, lastName, email, username, loading, success, error } = this.state;
        
        try {
            const userData = localStorage.getItem('user');
            if (!userData) {
                return <Navigate to="/login" replace />;
            }
        } catch (error) {
            return <Navigate to="/login" replace />;
        }

        return (
            <div className="container">
                <div style={{ marginTop: '20px', maxWidth: '800px' }}>
                    <div style={{ marginBottom: '30px' }}>
                        <h4>Profile Settings</h4>
                        <p className="text-muted">Manage your account information and preferences</p>
                    </div>

                    {success && (
                        <Alert variant="success" onClose={() => this.setState({ success: false })} dismissible>
                            Profile updated successfully!
                        </Alert>
                    )}

                    {error && (
                        <Alert variant="danger" onClose={() => this.setState({ error: '' })} dismissible>
                            {error}
                        </Alert>
                    )}

                    <Form onSubmit={this.handleSubmit}>
                        <FormGroup className="row" as={Row} controlId="formUsername" style={{ marginBottom: '15px' }}>
                            <Col sm={3}>
                                <Form.Label>Username</Form.Label>
                            </Col>
                            <Col sm={9}>
                                <FormControl 
                                    type="text" 
                                    value={username} 
                                    disabled 
                                    style={{ backgroundColor: '#f5f5f5' }}
                                />
                                <Form.Text className="text-muted">
                                    Username cannot be changed
                                </Form.Text>
                            </Col>
                        </FormGroup>

                        <FormGroup className="row" as={Row} controlId="formFirstName" style={{ marginBottom: '15px' }}>
                            <Col sm={3}>
                                <Form.Label>First Name</Form.Label>
                            </Col>
                            <Col sm={9}>
                                <FormControl 
                                    type="text" 
                                    name="firstName"
                                    value={firstName} 
                                    onChange={this.handleChange}
                                    placeholder="Enter your first name"
                                />
                            </Col>
                        </FormGroup>

                        <FormGroup className="row" as={Row} controlId="formLastName" style={{ marginBottom: '15px' }}>
                            <Col sm={3}>
                                <Form.Label>Last Name</Form.Label>
                            </Col>
                            <Col sm={9}>
                                <FormControl 
                                    type="text" 
                                    name="lastName"
                                    value={lastName} 
                                    onChange={this.handleChange}
                                    placeholder="Enter your last name"
                                />
                            </Col>
                        </FormGroup>

                        <FormGroup className="row" as={Row} controlId="formEmail" style={{ marginBottom: '15px' }}>
                            <Col sm={3}>
                                <Form.Label>Email</Form.Label>
                            </Col>
                            <Col sm={9}>
                                <FormControl 
                                    type="email" 
                                    name="email"
                                    value={email} 
                                    onChange={this.handleChange}
                                    placeholder="Enter your email address"
                                />
                            </Col>
                        </FormGroup>

                        <div style={{ marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #dee2e6' }}>
                            <h5 style={{ marginBottom: '15px' }}>Security</h5>
                            <p className="text-muted" style={{ marginBottom: '15px' }}>
                                To change your password, please visit the change password page.
                            </p>
                            <Link to="/changepassword">
                                <Button variant="outline-primary">
                                    Change Password
                                </Button>
                            </Link>
                        </div>

                        <div style={{ marginTop: '30px', display: 'flex', gap: '10px' }}>
                            <Button 
                                variant="primary" 
                                type="submit" 
                                disabled={loading}
                            >
                                {loading ? 'Saving...' : 'Save Changes'}
                            </Button>
                            <Button 
                                variant="secondary" 
                                type="button"
                                onClick={() => {
                                    // Reset form to original values
                                    const user = JSON.parse(localStorage.getItem('user'));
                                    this.setState({
                                        firstName: user.firstName || '',
                                        lastName: user.lastName || '',
                                        email: user.email || '',
                                        success: false,
                                        error: ''
                                    });
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

export { Profile };

